import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const hh = Math.floor(seconds / 3600);
  const mm = Math.floor(seconds % 3600 / 60);
  const ss = seconds % 60;
  return {
    hh,
    mm,
    ss
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-31" data-mp="3h20gp93lchj0">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl border border-gold/25 bg-ink font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-32" data-mp="3gymfw5aksgdo">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-33" data-mp="10dejno4hx1u6">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 54 * 60 + 30);
  return <section aria-label="Cuenta regresiva" className="bg-ink" data-id="element-34" data-mp="xz3oa76eved0">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center pt-[28px] pb-[0px]" data-id="element-35" data-mp="t1aihf90smd9">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-36" data-mp="17py8l603k3vt">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-37" data-mp="12tzqg05d3i3u">
          <Unit value={hh} label="Horas" data-id="element-38" data-mp="f2uazm3c2ru2" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-39" data-mp="a37nmjtsjv7j">:</span>
          <Unit value={mm} label="Min" data-id="element-40" data-mp="a5bwzhaglmf7" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="o38z0t7oml19">:</span>
          <Unit value={ss} label="Seg" data-id="element-42" data-mp="k1nc0f1foqdc" />
        </div>
        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-43" data-mp="k03wwrrikld5">
          ⚠️ Después sube AR$ 35.000 ARS. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-44" data-mp="1vgu68jr8htaz">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-45" data-mp="1vg0vl7p5mjnk">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-46" data-mp="x4rb1es071vn">
            <div className="h-full w-[68%] rounded-full bg-azul" data-id="element-47" data-mp="x6ubytup2ff5" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-gold" data-id="element-48" data-mp="124cfg4py02fr">
            68% tomados — Quedan pocos
          </p>
        </div>
      </div>
    </section>;
}